// @flow weak

import React      from 'react';
import PropTypes  from 'prop-types';

const TabPanel = ({
  children
}) => (
  <section className="tab-panel-nik panel general">
    {children}
  </section>
);

TabPanel.propTypes = {
  children: PropTypes.node.isRequired
};

export default TabPanel;



// WEBPACK FOOTER //
// ./src/app/components/tabPanel/TabPanel/TabPanel.js